import { batch } from 'react-redux';
import { DEFAULT_TABLE_RESULT_MODEL, ROUTE_LINK_LOCATION, UPLOAD_TYPES } from '../../../../constants/external-constants';
import {
    setHeaderNotifications,
    setShowHeaderNotificationModal,
    setUnreadHeaderNotifications,
    setMatchAuditErrorDetails,
    setUploadErrorDetails,
    setChargeMappingErrorDetails,
    setErrorDetaisLoading
} from '../../../../constants/model-reducers/notification.settings';
import { httpDownload, httpGet, httpPost } from '../../../../utils/api.utils';
import { convertToFormatLocalDate, convertToPagedList, headerColumnProps } from '../../../../utils/helpers.utils';
import NotificationHubConnector from '../../../../utils/signalr-connection';

const defaultState = () => ({
    header: [],
    showHeaderNotificationModal: false,
    hasUnreadHeaderNotification: false,
    errorDetails: {
        isLoading: false,
        matchAudit: DEFAULT_TABLE_RESULT_MODEL,
        upload: DEFAULT_TABLE_RESULT_MODEL,
        chargeMapping: DEFAULT_TABLE_RESULT_MODEL
    }
});

const initialState = defaultState();

export const notificationActions = {
    connectHeaderNotification: () => async (dispatch) => {
        try {
            const userId = JSON.parse(sessionStorage.getItem("User")).Employee.UserId;
            const userEmail = JSON.parse(sessionStorage.getItem("User")).Employee.Email;
            const groupName = "header-notif";
            const userConnection = { UserID: userId, UserEmail: userEmail, Group: groupName };

            const { events } = NotificationHubConnector("ConnectHeaderNotification", userConnection);

            const handleMessageReceived = (notifications) => {
                const newNotifications = mapHeaderNotifications(notifications);
                const hasUnreadNotifications = newNotifications.filter(i => i.markAsRead == false).length > 0;
                const hasOutputRecord = newNotifications.filter(i => i.subTitleHeader == "Generate Output").length > 0;

                dispatch({
                    type: setHeaderNotifications,
                    data: {
                        notifications: newNotifications,
                        hasUnreadNotifications: hasUnreadNotifications
                    }
                });
            };

            events(handleMessageReceived);
        }
        catch (e) {
        }
    },
    deleteHeaderNotification: (matchAuditLogId, uploadTypeId) => async () => {
        try {
            await httpPost(`external/notification/headerNotification/delete/${matchAuditLogId}/${uploadTypeId}`);
        }
        catch (e) {
        }

        return true;
    },
    markAsReadHeaderNotification: () => (dispatch) => {
        callMethodHeaderNotification("MarkAsReadHeaderNotification");

        dispatch({
            type: setUnreadHeaderNotifications,
            data: false
        });
    },
    toggleHeaderNotificationModal: (isShow) => (dispatch) => {
        dispatch({
            type: setShowHeaderNotificationModal,
            data: isShow
        });
    },
    viewMoreHeaderNotification: () => (_, state) => {
        const { header } = state().notifications;
        var pageSize = header.data.length + 5;
        callMethodHeaderNotification("GetHeaderNotifications", pageSize);
    },
    viewError: (id, uploadTypeId, pageIndex = 0, errorType='', sortColPropName = null, isSortedAsc = null, isInvoiceUpload = true) => async (dispatch, state) => {
        try {
            var result=null;
            dispatch({
                type: setErrorDetaisLoading,
                data: true
            });
            if (uploadTypeId == UPLOAD_TYPES.InvoiceMatchAudit) {
                result = await httpGet(`external/notification/headerNotification/matchAudit/errorDetails/${id}`);
                dispatch({
                    type: setMatchAuditErrorDetails,
                    data: result
                });
            }
            else if (uploadTypeId == UPLOAD_TYPES.InvoiceUpload) {
                const { Pagination } = state().notification.errorDetails.upload;

                result = await httpGet(`external/notification/headerNotification/upload/errorDetails/${id}/${pageIndex}/${Pagination.PerPage}/${uploadTypeId}`);
                dispatch({
                    type: setUploadErrorDetails,
                    data: result.upload
                });
            }
            else if (uploadTypeId == UPLOAD_TYPES.ChargeTypeUpload) {
                const { Pagination, SortedColumnName, IsSortAscending } = state().notification.errorDetails.chargeMapping;

                sortColPropName = sortColPropName ?? SortedColumnName;
                isSortedAsc = (isSortedAsc ?? IsSortAscending) ? 1 : 0;

                const filterQuery = !sortColPropName ? '' : `?sortColPropertyName=${sortColPropName}&isSortAscending=${isSortedAsc}`;

                if (!isInvoiceUpload) {
                    result = await httpGet(`external/notification/headerNotification/upload/errorDetails/${id}/${pageIndex}/${Pagination.PerPage}/${uploadTypeId}`);
                    dispatch({
                        type: setUploadErrorDetails,
                        data: result.upload
                    });
                }
                else {
                    result = await httpGet(`external/notification/headerNotification/chargeMapping/errorDetails/${id}/${pageIndex}/${Pagination.PerPage}${filterQuery}`);
                    dispatch({
                        type: setChargeMappingErrorDetails,
                        data: result.chargeMapping
                    });
                }
            }
            else if (uploadTypeId == UPLOAD_TYPES.RateCardUpload)
            {
                const { Pagination } = state().notification.errorDetails.upload;

                result = await httpGet(`external/notification/headerNotification/upload/errorDetails/${id}/${pageIndex}/${Pagination.PerPage}/${uploadTypeId}`);
                dispatch({
                    type: setUploadErrorDetails,
                    data: result.upload
                });
            }
            else if (uploadTypeId == UPLOAD_TYPES.DebitorUpload)
            {
                const { Pagination } = state().notification.errorDetails.upload;

                result = await httpGet(`external/notification/headerNotification/upload/errorDebitorUpload/${id}/${pageIndex}/${Pagination.PerPage}/${uploadTypeId}`);
                dispatch({
                    type: setUploadErrorDetails,
                    data: result.upload
                });
            }
            else if (uploadTypeId == UPLOAD_TYPES.ArticleUpload 
                    || uploadTypeId == UPLOAD_TYPES.RechargeMappingInventory 
                    || uploadTypeId == UPLOAD_TYPES.RechargingOutputRecordGeneration
                    || uploadTypeId == UPLOAD_TYPES.RechargingOutputGeneration)
            {
                const { Pagination } = state().notification.errorDetails.upload;

                let url = `external/notification/headerNotification/upload/errorUploadInfo/${id}/${pageIndex}/${Pagination.PerPage}/${uploadTypeId}`;
                
                if (errorType && errorType.trim() !== '') {
                    url += `/${encodeURIComponent(errorType)}`;
                }

                result = await httpGet(url);

                dispatch({
                    type: setUploadErrorDetails,
                    data: result.upload
                });
            }
            else if (uploadTypeId == UPLOAD_TYPES.CircuitWireless)
            {
                const { Pagination } = state().notification.errorDetails.upload;

                result = await httpGet(`external/notification/headerNotification/upload/errorUploadWithSheetName/${id}/${pageIndex}/${Pagination.PerPage}/${uploadTypeId}`);
                dispatch({
                    type: setUploadErrorDetails,
                    data: result.upload
                });
            }
            else if (uploadTypeId == UPLOAD_TYPES.HrUpload)
            {
                const { Pagination } = state().notification.errorDetails.upload;

                result = await httpGet(`external/notification/headerNotification/hrUpload/errorDetails/${id}/${pageIndex}/${Pagination.PerPage}/${uploadTypeId}`);
                dispatch({
                    type: setUploadErrorDetails,
                    data: result.upload
                });
            }
        }
        catch {
            dispatch({
                type: setErrorDetaisLoading,
                data: false
            });
        }
    },
    extractChargeMappingErrorDetail: (batchId) => (_, state) => {
        try {
            const { activeDateFormat } = state().adminSetting;
            
            const dealName = sessionStorage.getItem('DealName');
            const currentDate = convertToFormatLocalDate(new Date(), activeDateFormat.Name).replaceAll('/', '-');
            const fileName = `ATEM ${dealName.toUpperCase()} - Charge Mapping Error Extract - ${currentDate}`;

            httpDownload(`external/notification/headerNotification/chargeMapping/export/errorDetails/${batchId}/${fileName}`)
                .then(function (response) {
                    return response.blob();
                })
                .then(function (blob) {
                    let downloadUrl = window.URL.createObjectURL(blob);
                    //Hide Loading
                    let a = document.createElement('a');
                    if (window.navigator.msSaveOrOpenBlob) {
                        window.navigator.msSaveOrOpenBlob(blob, fileName);
                    } else if (typeof a.download === 'undefined') {
                        window.location = downloadUrl;
                    } else {
                        a.href = downloadUrl;
                        a.download = fileName + '.xlsx';
                        document.body.appendChild(a);
                        a.click();
                    }
                });
        }
        catch { }
    },
    extractHrUploadErrorDetail: (batchId) => (_, state) => {
        try {
            const { activeDateFormat } = state().adminSetting;

            const dealName = sessionStorage.getItem('DealName');
            const currentDate = convertToFormatLocalDate(new Date(), activeDateFormat.Name).replaceAll('/', '-');
            const fileName = `ATEM ${dealName.toUpperCase()} - HR Upload Error Extract - ${currentDate}`;

            httpDownload(`external/notification/headerNotification/hrUpload/export/errorDetails/${batchId}/${fileName}`)
                .then(function (response) {
                    return response.blob();
                })
                .then(function (blob) {
                    let downloadUrl = window.URL.createObjectURL(blob);
                    //Hide Loading
                    let a = document.createElement('a');
                    if (window.navigator.msSaveOrOpenBlob) {
                        window.navigator.msSaveOrOpenBlob(blob, fileName);
                    } else if (typeof a.download === 'undefined') {
                        window.location = downloadUrl;
                    } else {
                        a.href = downloadUrl;
                        a.download = fileName + '.xlsx';
                        document.body.appendChild(a);
                        a.click();
                    }
                });
        }
        catch { }
    },
    extractRechargeOutputGenErrorDetail: (batchId, errorIdentifierID) => (_, state) => {
        try {
            const { activeDateFormat } = state().adminSetting;

            const dealName = sessionStorage.getItem('DealName');
            const currentDate = convertToFormatLocalDate(new Date(), activeDateFormat.Name).replaceAll('/', '-');
            const fileName = `ATEM ${dealName.toUpperCase()} Recharging Output Generation ${errorIdentifierID} Error Extract - ${currentDate}`;

            httpDownload(`external/notification/headerNotification/rechargingoutputgen/export/errorDetails/${batchId}/${fileName}`)
                .then(function (response) {
                    return response.blob();
                })
                .then(function (blob) {
                    let downloadUrl = window.URL.createObjectURL(blob);
                    //Hide Loading
                    let a = document.createElement('a');
                    if (window.navigator.msSaveOrOpenBlob) {
                        window.navigator.msSaveOrOpenBlob(blob, fileName);
                    } else if (typeof a.download === 'undefined') {
                        window.location = downloadUrl;
                    } else {
                        a.href = downloadUrl;
                        a.download = fileName + '.xlsx';
                        document.body.appendChild(a);
                        a.click();
                    }
                });
        }
        catch { }
    },
    extractCircuitWirelessErrorDetail: (batchId) => (_, state) => {
        try {
            const { activeDateFormat } = state().adminSetting;
            
            const dealName = sessionStorage.getItem('DealName');
            const currentDate = convertToFormatLocalDate(new Date(), activeDateFormat.Name).replaceAll('/', '-');
            const fileName = `ATEM ${dealName.toUpperCase()} - Inventory Upload Error Extract - ${currentDate}`;

            httpDownload(`external/notification/headerNotification/uploaderror/export/errorDetails/${batchId}/${fileName}`)
                .then(function (response) {
                    return response.blob();
                })
                .then(function (blob) {
                    let downloadUrl = window.URL.createObjectURL(blob);
                    //Hide Loading
                    let a = document.createElement('a');
                    if (window.navigator.msSaveOrOpenBlob) {
                        window.navigator.msSaveOrOpenBlob(blob, fileName);
                    } else if (typeof a.download === 'undefined') {
                        window.location = downloadUrl;
                    } else {
                        a.href = downloadUrl;
                        a.download = fileName + '.xlsx';
                        document.body.appendChild(a);
                        a.click();
                    }
                });
        }
        catch { }
    },
    resetErrorDetails: () => (dispatch) => {
        batch(() => {
            dispatch({
                type: setMatchAuditErrorDetails,
                data: initialState.errorDetails.matchAudit
            });
            dispatch({
                type: setUploadErrorDetails,
                data: initialState.errorDetails.upload
            });
            dispatch({
                type: setChargeMappingErrorDetails,
                data: initialState.errorDetails.chargeMapping
            });
        });
    }
}

function callMethodHeaderNotification(methodName, args) {
    const userId = JSON.parse(sessionStorage.getItem("User")).Employee.UserId;
    const userEmail = JSON.parse(sessionStorage.getItem("User")).Employee.Email;
    const groupName = "header-notif";
    const userConnection = { UserID: userId, UserEmail: userEmail, Group: groupName };

    const { callMethod } = NotificationHubConnector("ConnectHeaderNotification", userConnection);
    callMethod(methodName, args);
}

function mapHeaderNotifications(notifications) {

    const newNotifications = notifications.map(i => {

        let errorHeaders = {
            type: headerColumnProps("type", "Error Type"),
            message: headerColumnProps("message", "Error Message")
        };

        if (i.uploadTypeId == UPLOAD_TYPES.InvoiceUpload || i.uploadTypeId == UPLOAD_TYPES.ChargeTypeUpload) {
            errorHeaders = {
                type: headerColumnProps("type", "Error Type"),
                vendor: headerColumnProps("vendor", "Vendor"),
                message: headerColumnProps("message", "Error Message")
            };
        }

        const newItem = {
            ...i,
            subTitleData: {
                ...i.subTitleData,
                link: `${ROUTE_LINK_LOCATION.invoiceRouteLink}/${i.subTitleData.key}`
            },
            errorDetailsTable: {
                headers: errorHeaders,
                data: convertToPagedList(i.errorDetails, 0, 1)
            }
        };

        return newItem;
    });

    return newNotifications;
}

export const reducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case setHeaderNotifications:
            return {
                ...state,
                header: action.data.notifications,
                hasUnreadHeaderNotification: action.data.hasUnreadNotifications
            };
        case setUnreadHeaderNotifications:
            return {
                ...state,
                hasUnreadHeaderNotification: action.data
            };
        case setShowHeaderNotificationModal:
            return {
                ...state,
                showHeaderNotificationModal: action.data
            };
        case setMatchAuditErrorDetails:
            return {
                ...state,
                errorDetails: {
                    ...state.errorDetails,
                    matchAudit: action.data,
                    isLoading: false
                }
            };
        case setUploadErrorDetails:
            return {
                ...state,
                errorDetails: {
                    ...state.errorDetails,
                    upload: action.data,
                    isLoading: false
                }
            };
        case setChargeMappingErrorDetails:
            return {
                ...state,
                errorDetails: {
                    ...state.errorDetails,
                    chargeMapping: action.data,
                    isLoading: false
                }
            };
        case setErrorDetaisLoading:
            return {
                ...state,
                errorDetails: {
                    ...state.errorDetails,
                    isLoading: action.data
                }
            };
        default:
            return state;
    }
}